import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Box, Typography, Button, Paper, Container } from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

const DesktopAuthDone = () => {
  const history = useHistory();
  const theme = useTheme();

  const handleContinue = () => {
    history.push("/");
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          textAlign: "center",
          p: 3,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 2,
            width: "100%",
            maxWidth: 500,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            bgcolor: "background.paper",
            boxShadow: "none",
          }}
        >
          <CheckCircleOutline
            sx={{
              fontSize: 80,
              color: theme.palette.success.main,
              mb: 2,
            }}
          />

          <Typography variant="h4" component="h1" gutterBottom>
            Sign-in Complete
          </Typography>

          <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
            You can now continue on the desktop client.
          </Typography>

          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleContinue}
            sx={{
              borderRadius: "50px",
              textTransform: "none",
              px: 4,
              py: 1.5,
              fontSize: "1.1rem",
              boxShadow: "none",
            }}
          >
            Go to Main Page
          </Button>
        </Paper>
      </Box>
    </Container>
  );
};

export default DesktopAuthDone;
